<div class="address-picker">
  @if (showForm) {
    <app-billing-address-form [submitting]="submitting" (saved)="onFormSaved($event)" (cancel)="onFormCancel()"></app-billing-address-form>
  } @else {
    @if (showSearch) {
      <input class="address-search" type="text" name="addressSearch" [(ngModel)]="query"
        [placeholder]="'customerCards.searchAddress' | translate"
        [attr.aria-label]="'customerCards.searchAddress' | translate">
    }

    <div class="address-list" role="radiogroup" [attr.aria-label]="'customerCards.billingInformation' | translate">
      @for (row of rows; track row.key) {
        <label class="address-option" [class.address-option--selected]="row.selected">
          <input class="address-option__input" type="radio" [name]="groupName"
            [checked]="row.selected" (change)="selectRow(row)">
          <span class="address-option__radio" aria-hidden="true"></span>
          <span class="address-option__text">
            <span class="address-option__line">{{ row.address.address }}</span>
            <span class="address-option__detail">{{ detail(row.address) }}</span>
          </span>
          <span class="address-option__tags">
            @if (row.isCurrent) {
              <span class="tag tag--current">{{ 'customerCards.currentTag' | translate }}</span>
            }
            @if (row.usedByOthers > 0) {
              <span class="tag tag--used">
                {{ usedByKey(row.usedByOthers) | translate: { count: row.usedByOthers } }}
              </span>
            }
          </span>
        </label>
      } @empty {
        <p class="address-empty">{{ 'customerCards.noAddressesFound' | translate }}</p>
      }
    </div>

    <button type="button" class="new-address-btn" (click)="openForm()">
      <span class="new-address-btn__plus" aria-hidden="true">+</span>
      {{ 'customerCards.addNewAddress' | translate }}
    </button>
  }
</div>
